import * as api from '../api'

export const getMaintenanceRequests = () => async (dispatch) => {
  try {
    const { data } = await api.fetchMaintenanceRequests()
    dispatch({ type: 'FETCH_MAINTENANCE_REQUESTS', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error,
    })
  }
}
